import Factory from './utils/factory'
import Address from './Address'

export default Factory({
  id: null,
  name: null,
  email: null,
  phone: null,
  address: Address(),
  birthdate: null,
  gender: null,
  company: null,
  upsell: false,
  assignees: [],
  tags: [],
  customFields: null,
})
